module.exports = "/lucky-balls/img/bigball/BigBall_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_001.png
// module id = 896
// module chunks = 0